import { VM } from "../../../core/VM"
import {Form as DekstopForm} from "./desktop/Form" 
import {Form as MobileForm} from "./mobile/Form" 

export const Adjustment = ({match})=>{

    const view = VM()

    return (
        view === '' ? 
            // DESKTOP
            <DekstopForm match={match}/>
        :  
            // MOBILE
            <MobileForm match={match}/>
    )
}
